import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import { createLogger } from "redux-logger";
import rootReducer from "../_reducers";
import storage from "redux-persist/lib/storage";

const loggerMiddleware = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
    key: "root",
    storage: storage
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// // store creating for redux and enable logger to watch store actions
// export const store = createStore(
//     rootReducer,
//     composeEnhancers(
//         applyMiddleware(
//             thunkMiddleware,
//             loggerMiddleware
//         )
//     )
// );

const configStore = (initialState = {}) => {
    const store = createStore(
        persistedReducer,
        initialState,
        composeEnhancers(
            applyMiddleware(
                thunk,
               // loggerMiddleware
            )
        )
    );
    return {
        persistor: persistStore(store),
        store
    };
};

const { store, persistor } = configStore();
global.store = store;

export { store, persistor };